let utils = require('../../utils')
import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'company_notice_result',
  created () {
    // TODO: 一覧取得
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      companyNoticeList: [],
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {}
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_COMPANY_NOTICE_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.companyNoticeList = this.companyNoticeList.concat(res.company_notices)
      } else {
        this.companyNoticeList = res.company_notices
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    async goDataDownload (id) {
      let data = {
        notice_id: id
      }

      let res = await this.$store.dispatch('GET_COMPANY_NOTICE_RESULT_CSV', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.onResultDownloadCsv(res.csv_data, res.company_notice_title.notice_title)
    },
    onResultDownloadCsv: function (data, title) {
      const csvFileName = DayJs().format('YYYYMMDD') + '_既読状況.csv'
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = title + '\n店舗名,役職,社員名,既読状況\n'
      data.forEach(obj => {
        if (obj.shop_name) {
          csv += this.enquoteForCSV(obj.shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_type_name) {
          csv += this.enquoteForCSV(obj.user_type_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_name) {
          csv += this.enquoteForCSV(obj.user_name) + ','
        } else {
          csv += ','
        }
        if (obj.is_already_read != null) {
          if (this.enquoteForCSV(obj.is_already_read) == 0) {
            csv += '未読'
          } else if (this.enquoteForCSV(obj.is_already_read) == 1) {
            csv += '既読'
          } else {
            csv += '不明'
          }
        } else {
          csv += '不明'
        }
        csv += '\n'
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    startDateFormat (startDate) {
      return DayJs(startDate).format('YYYY年MM月DD日')
    },
    endDateFormat (endDate) {
      return DayJs(endDate).format('YYYY年MM月DD日')
    },
    isSendMail (isMailDelivery) {
      if (isMailDelivery == 1) {
        return '配信あり'
      } else {
        return '配信なし'
      }
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-result.js